import styled from 'styled-components';
import { tooltipMixin } from '../../../styles/tooltipMixin';


export const BuscadorTop = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
`;

export const ContainerBuscador = styled.div`
  background-color: white;
  border-radius: 30px;
  padding: 3px 10px 2px 4px;
  position: relative;
  display: flex;
  align-items: center;
  width: clamp(300px, 30vw, 520px);
`;

export const FiltroBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  padding: 0 10px 0 12px;
  height: 35px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  &:hover { color: rgb(111, 72, 218); }
`;

export const FiltroBadge = styled.span`
  background: rgb(111, 72, 218);
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FiltroSep = styled.span`
  display: inline-block;
  width: 1px;
  height: 20px;
  background: #ddd;
  flex-shrink: 0;
`;

export const VistaBtn = styled.button`
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  padding: 0 8px 0 10px;
  height: 35px;
  font-size: 16px;
  color: ${p => p.active ? 'rgb(111, 72, 218)' : '#888'};
  cursor: pointer;
  flex-shrink: 0;
  &:hover { color: rgb(111, 72, 218); }
  
`;

export const SearchBox = styled.input`
  background-color: transparent;
  outline: none;
  height: 35px;
  font-size: 15px;
  border: 0;
  flex: 1;
  min-width: 0;
  padding-left: 8px;
  &:disabled { opacity: 0.4; cursor: not-allowed; }
`;
/****  bOTON DE go *** */
export const SearchButton = styled.button`
  position: absolute;
  right: 4px;
  top: 2px;
  background-color: rgb(111, 72, 218);
  border-radius: 50%;
  border: 0;
  width: 35px;
  height: 35px;
  outline: 0;
  color: white;
  cursor: pointer;
  &:disabled { opacity: 0.3; cursor: not-allowed; }
`;
export const TooltipWrap = styled.div`
  position: relative;
  width: 100%;
  ${tooltipMixin('center')}
`;